<template>
  <div>
    <CCard>
      <CCardHeader>
        Buyer Payment History for All Buyers
      </CCardHeader>

      <CCardBody>
        <div
          v-if="isLoading"
          :style="{ height: '80vh' }"
          class="d-flex flex-column justify-content-center align-items-center"
        >
          <CSpinner
            style="width: 4rem; height: 4rem"
            color="info"
            grow
          />
        </div>

        <div v-else>
          <BuyerPaymentHistoryList
            :payments="paymentHistory"
            show-account-name
          />
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import startCase from 'lodash.startcase'

import BillingAPI from '@/api/billing.api'
import BuyerPaymentHistoryList from './BuyerPaymentHistoryList.vue'
import { dateTimeFormat } from '@/utils'

function getPaidByFromDescriptionForManualAdjustment(description) {
  return description.split('(')?.[0]
}

export default {
  name: 'BuyerAccountPaymentHistory',

  components: {
    BuyerPaymentHistoryList,
  },

  data() {
    return {
      accountId: '',
      isLoading: false,

      paymentHistory: []
    }
  },

  computed: {
    ...mapState('accounts', [
      'buyerAccountDetails',
    ]),
  },

  async created () {
    document.title = `Buyer Payment History`

    await this.getBuyersPaymentHistory()
  },

  methods: {
    ...mapActions('accounts', [
      'getBuyerAccountDetails',
    ]),

    async getBuyersPaymentHistory() {
      try {
        this.isLoading = true
        const response = await BillingAPI.getBuyersPaymentHistory()
  
        this.paymentHistory = response.data.map(payment => {
          return {
            ...payment,
            paidByName: payment.transactionType === 'ManualAdjustment' ? getPaidByFromDescriptionForManualAdjustment(payment.paymentDescription) : payment.paidBy?.name,
            formattedPaymentDate: dateTimeFormat.format(new Date(payment.paymentDate)),
            transactionType: startCase(payment.transactionType)
          }
        })
      } catch (error) {
        //
      } finally {
        this.isLoading = false
      }
    }
  },
}
</script>
<style>
  
</style>